import React from 'react';
import { Link } from 'react-router-dom';
import { PillPrimary } from '../components/PillButton';
import { heroImages, stats } from '../mock';
import { ArrowRight } from 'lucide-react';

const ChiSiamo = () => {
  return (
    <div className="bg-[#2b2b2b]">
      <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-[#141414]">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center">
          <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Chi siamo</div>
          <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">La nostra storia</h1>
          <p className="text-[#e9dfc0]/85 text-[17px] leading-relaxed max-w-3xl mx-auto">
            Nasce ETECH S.R.L., un'azienda giovane, dinamica e orientata al futuro dell'eCommerce. Il nostro team unisce esperienza senior e innovazione, con una visione chiara: rendere il commercio digitale semplice, efficace e sostenibile per ogni brand.
          </p>
        </div>
      </section>

      <section className="bg-[#3a3a3a] py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-4">Impatto</div>
            <h2 className="font-serif text-white text-4xl md:text-5xl">I numeri che parlano per noi</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {stats.map((s) => (
              <div key={s.label} className="bg-[#2b2b2b] border border-[#e9dfc0]/20 rounded-2xl p-10 text-center">
                <div className="font-serif text-[#e9dfc0] text-6xl md:text-7xl mb-4">{s.number}</div>
                <p className="text-[#e9dfc0]/85 text-sm leading-relaxed">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-center">
          <div className="aspect-square bg-cover bg-center rounded-2xl" style={{ backgroundImage: `url(${heroImages.team2})` }} />
          <div>
            <h2 className="font-serif text-white text-3xl md:text-4xl mb-6">L'incontro tra esperienza e innovazione</h2>
            <p className="text-[#e9dfc0]/85 leading-relaxed mb-4">ETech nasce dall'incontro tra professionisti senior con oltre 20 anni di esperienza nel retail e nella distribuzione, e un team giovane cresciuto nativo digitale, con competenze verticali su Shopify, Meta Ads, CRO e data analytics.</p>
            <p className="text-[#e9dfc0]/85 leading-relaxed">Non siamo un'agenzia. Siamo operatori che hanno lanciato brand con i propri soldi, testato mille errori sul proprio conto, e trasformato ogni fallimento in un metodo replicabile.</p>
          </div>
        </div>
      </section>

      <section className="bg-[#1e1e1e] py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="font-serif text-white text-3xl md:text-4xl mb-6">Il nostro modo di lavorare</h2>
            <p className="text-[#e9dfc0]/85 leading-relaxed mb-4">Trasparenza, prossimità e risultati misurabili sono i tre pilastri del nostro approccio. Non lavoriamo per commesse orarie: entriamo nei progetti come partner e cresciamo insieme ai brand che scegliamo.</p>
            <p className="text-[#e9dfc0]/85 leading-relaxed">Ci occupiamo di ogni tassello della macchina eCommerce: dalla strategia al design, dal media buying alla logistica, dall'amministrazione ai dati. Un solo team, un solo interlocutore.</p>
          </div>
          <div className="order-1 md:order-2 aspect-square bg-cover bg-center rounded-2xl" style={{ backgroundImage: `url(${heroImages.dashboard})` }} />
        </div>
      </section>

      <section className="bg-[#e9dfc0] py-20">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-serif text-[#2b2b2b] text-3xl md:text-4xl mb-6">Quello che abbiamo sempre fatto per i nostri brand, oggi lo mettiamo a disposizione anche del tuo.</h2>
          <Link to="/temporary-management" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#2b2b2b] text-[#e9dfc0] font-medium hover:bg-[#1e1e1e] transition-colors">
            Scopri ETech Temporary Management <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ChiSiamo;
